import { Box, Card } from '@mui/material';
import { Download } from '@mui/icons-material';
import FlexBetween from 'components/flexbox/FlexBetween';
import { Button, styled, Typography, Link } from '@mui/material';
import FileUpload from 'page-sections/group-registration/FileUpload';
import { useState, useCallback } from 'react';
import { v4 as uuidv4 } from 'uuid';
import axiosInstance from 'utils/axios';
import { useNavigate } from 'react-router-dom';

const StyledFlexBox = styled(FlexBetween)(({ theme }) => ({
    flexWrap: 'wrap',
    marginBottom: 20,
    [theme.breakpoints.down(500)]: {
        width: '100%',
        '& .MuiInputBase-root': {
            maxWidth: '100%',
        },
        '& .MuiButton-root': {
            width: '100%',
            marginTop: 15,
        },
    },
}));

const GroupRegistrationUploadPage = () => {
    const [error, setError] = useState();
    const [file, setFile] = useState(false);

    const navigate = useNavigate();

    const handleDropFile = useCallback(
        async (acceptedFiles, fileRejections) => {
            setError();

            fileRejections.forEach((file) => {
                file.errors.forEach((err) => {
                    if (err.code === 'file-too-large') {
                        setError(`Error: ${err.message}`);
                    }

                    if (err.code === 'file-invalid-type') {
                        setError(`Error: ${err.message}`);
                    }
                });
            });

            if (acceptedFiles.length > 0) {
                setFile(true);

                const formData = new FormData();
                const id = uuidv4();
                formData.append('id', id);
                formData.append('file', acceptedFiles[0]);
                await axiosInstance
                    .post('/api/register-groups', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data',
                            Authorization: `Bearer ${localStorage.getItem(
                                'accessToken',
                            )}`,
                        },
                    })
                    .then((res) => {
                        if (res.data.status === 'success') {
                            navigate(`/dashboard/group-registration/${id}`);
                        } else if (res.data.status === 'error') {
                            if (res.data.file) {
                                const linkSource = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${res.data.file}`;
                                const downloadLink =
                                    document.createElement('a');
                                const fileName =
                                    res.data.fileName || 'Error_Report.xlsx';
                                downloadLink.href = linkSource;
                                downloadLink.download = fileName;
                                downloadLink.click();
                            }
                            setError(res.data.message || 'Validation failed');
                            setFile(false);
                        }
                    })
                    .catch((err) => {
                        console.log(err);
                        setError(err.message || 'An error occurred');
                        setFile(false);
                    });
            }
        },
        [],
    );

    return (
        <Box pt={2} pb={4}>
            <Card sx={{ padding: 5 }}>
                <StyledFlexBox>
                    <Typography variant="h5">
                        Upload Registration Data
                    </Typography>
                    <Link
                        href="/assets/templates/Group Registration INAACC Semarang 2026.xlsx"
                        target="_blank"
                        download
                        underline="none"
                    >
                        <Button
                            size="small"
                            variant="contained"
                            endIcon={<Download />}
                        >
                            Download Template
                        </Button>
                    </Link>
                </StyledFlexBox>
            </Card>
            <Card sx={{ mt: 4 }}>
                <FileUpload onDrop={handleDropFile} error={error} file={file} />
            </Card>
        </Box>
    );
};

export default GroupRegistrationUploadPage;
